import UsersDataGrid from './UsersDataGrid'
import { Button, Grid } from '@mui/material'
import { Link } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';

const SuperAdminArchivedUserManagement = function() {

  return (
    <Grid container spacing={gridSpacing}>
      <Grid item xs={12}>
        <Button variant="contained" component={Link} to='/super-admin/user-management'>
            Return to Active Super Admins
        </Button>
      </Grid>

      <Grid item xs={12}>
        <MainCard title="Archived Super Admins">
            <UsersDataGrid active={false} />
        </MainCard>
      </Grid>
    </Grid>
  )
}

export default SuperAdminArchivedUserManagement